<button (click)="goUp()" class="btn btn-primary_search btn-icon scroll-top waves-effect waves-float waves-light hidden-xs" type="button"
  style="display: inline-block;">
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up">
    <line x1="12" y1="19" x2="12" y2="5"></line>
    <polyline points="5 12 12 5 19 12"></polyline>
    <title>{{'footer.tituloVolver' | translate}}</title>
  </svg>
</button>





<!-- Footer -->
<footer class="pos_relative mt-2" >


  <!-- Grid container -->
  <div class="container p-1 ">


    <!-- Section: Links -->
    <section class="">
      <!--Grid row-->
      <div class="row">


        <!--Grid column-->
        <div class="col-4 col-lg-3 col-md-6 mb-0 mb-md-0">
          <section class="mb-4">
            <!-- Facebook -->
            <a class="btn btn-outline-light btn-floating m-1 active" href="{{redes.facebook}}" title="{{'footer.tituloFacebook' | translate}}" target="_blank" role="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-facebook">
                <title>Ir a la página de Facebook de ChilePasajes</title>
                <desc>Visita nuestra página de Facebook para obtener más información.</desc>
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>

            <!-- Twitter -->
            <a class="btn btn-outline-light btn-floating m-1 active" href="{{redes.twitter}}" title="{{'footer.tituloX' | translate}}" target="_blank" role="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-twitter">
                <title>Ir a la página de Twitter de ChilePasajes</title>
                <desc>Visita nuestra página de Twitter para obtener más información.</desc>
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
              </a>

              <!-- Instagram -->
              <a class="btn btn-outline-light btn-floating m-1 active" href="{{redes.instagram}}" title="{{'footer.tituloInstagram' | translate}}" target="_blank"  role="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-instagram">
                  <title>Ir a la página de Instagram de ChilePasajes</title>
                  <desc>Visita nuestra página de Instagram para obtener más información.</desc>
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                </a>

                <!-- Youtube -->
                <a class="btn btn-outline-light btn-floating m-1 active" href="{{redes.youtube}}" title="{{'footer.tituloYoutube' | translate}}" target="_blank"  role="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-youtube">
                    <title>Ir al Canal de Youtube de ChilePasajes</title>
                    <desc>Visita nuestro canal para obtener más información.</desc>
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                  </a>

                </section>
              </div>
              <!--Grid column-->

              <!--Grid column-->
              <div class="col-6 col-lg-5 col-md-6 mb-0 mb-md-0">
                <h5 class="text-uppercase option-title">{{'menu.gestionBoletosMapa' | translate}}</h5>

                <ul class="list-unstyled mb-0">
                  <li>
                    <a [routerLink]="['/' + this.lang + '/gestion-boletos']" title="{{'footer.tituloBoletos' | translate}}" >{{'menu.gestionBoletos2' | translate}}</a>
                  </li>
                  @if (checkComplLogin) {
                    <li>
                      <a [routerLink]="['/' + this.lang + '/mapa-del-sitio']" title="Lista completa de todas las páginas de chilepasajes.cl" >{{'menu.mapaSitio' | translate}}</a>
                    </li>
                  }
                </ul>
                <h5 class="text-uppercase option-title">{{'menu.termPrivacidad' | translate}}</h5>
                <ul class="list-unstyled mb-0">
                  <li>
                    <a [routerLink]="['/' + this.lang + '/terminos-y-condiciones']" title="{{'footer.tituloTermYcond' | translate}}" >{{'menu.termCondiciones' | translate}}</a>
                  </li>
                  <li>
                    <a [routerLink]="['/' + this.lang + '/politicas-privacidad']" title="{{'footer.tituloPrivacidad' | translate}}" >{{'menu.poliPrivacidad' | translate}}</a>
                  </li>

                </ul>
              </div>
              <!--Grid column-->

              <!--Grid column-->
              <div class="col-lg-4 col-md-6 mb-0 mb-md-0">

                <h5 class="text-uppercase option-title">{{'menu.poliAyuda' | translate}}</h5>

                <ul class="list-unstyled mb-0">
                  <li>
                    <a  [routerLink]="['/' + this.lang + '/politicas-cookies']" title="{{'footer.tituloCookies' | translate}}" >{{'menu.poliCookies' | translate}}</a>
                  </li>
                  <li>
                    <a [routerLink]="['/' + this.lang + '/ayuda']" title="{{'footer.tituloInfo' | translate}}" >{{'menu.servicioCliente' | translate}}</a>
                  </li>
                  <li>
                    <a href='https://blog.chilepasajes.cl/' title="{{'footer.tituloblog' | translate}}" >{{'menu.blog' | translate}}</a>
                  </li>
                </ul>
                <h5 class="text-uppercase option-title">{{'menu.servicios' | translate}}</h5>

                <ul class="list-unstyled mb-0">
                  <li>
                    <a [routerLink]="['/' + this.lang + '/bus']" title="{{'footer.tituloBuses' | translate}}" >{{'menu.buses' | translate}}</a>
                  </li>
                  <!-- <li>
                    <a [routerLink]="['/' + this.lang + '/transfer']" title="{{todoElIdioma.footer.tituloTransfer}}" class="text-white">Transfer</a>
                  </li> -->

                </ul>
              </div>
              <!--Grid column-->
            </div>
            <!--Grid row-->
          </section>
          <!-- Section: Links -->
        </div>
        <!-- Grid container -->

        <!-- Copyright -->
  <div class="text-center p-3" style="    background-color: #f6f6f6;
  color: #0000006b;
  border-top: 1px solid #9e9e9e42;">
          © 2024 ChilePasajes SPA.<br>Profesora Amanda Labarca #124, piso 9, Santiago de Chile. +56 22 5952974
        </div>
        <!-- Copyright -->
      </footer>
      <!-- Footer -->


      <!-- <footer class="footer footer-static footer-light d-none">
      <p class="clearfix mb-0">
        <span class="float-md-start d-block d-md-inline-block mt-25"> 2023 ChilePasajes SPA, Alameda 4050, Estación Central, Santiago de Chile. +56 22 5952974
          <span class="d-none d-sm-inline-block">, Todos los derechos reservados </span> </span> <span class="float-md-end"> desarrollado con<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart">
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
          </path>
        </svg> en Chile.</span>
        <span (click)="pageGo('1')" class="float-md-start d-block d-md-inline-block mt-25 ml-5 asd">
          Términos y Condiciones
        </span>
        <span (click)="pageGo('2')" class="float-md-start d-block d-md-inline-block mt-25 ml-5 asd">
          Póliticas de Cookies
        </span>
        <span (click)="pageGo('3')" class="float-md-start d-block d-md-inline-block mt-25 ml-5 asd">
          Póliticas de Privacidad
        </span>
      </p>
    </footer> -->
